<template>
  <div v-loading="isLoging">
    <el-dialog
      :title=title
      width="40%"
      top="2rem"
      :close-on-click-modal="false"
      :visible.sync="showDialog"
      :destroy-on-close="true"
      @close="close()"
    >
      <div style="margin-top: 1rem;margin-right: 100px;">
        <el-form ref="alarmFormRef" :rules="rules" :model="form" label-width="140px" >
          <el-form-item label="告警设备名称" prop="deviceName">
            <el-input v-model="form.deviceName" clearable :disabled="form.id"></el-input>
          </el-form-item>
          <el-form-item label="告警等级" prop="alarmLevel">
            <el-select
              v-model="alarmLevel"
              style="width: 100%"
              placeholder="请选择告警等级"
              @change="changeLevel"
            >
              <el-option v-for="item in levelList" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="告警类型" prop="alarmType">
            <el-select
              v-model="alarmType"
              style="width: 100%"
              placeholder="请选择告警类型"
              @change="changeCompany"
              :disabled="form.id"
            >
              <el-option v-for="item in dropDownList" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="告警描述" prop="alarmDescription">
            <el-input v-model="form.alarmDescription" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <div style="float: right;">
              <el-button type="primary" @click="onSubmit" :loading="dialogLoading" >保存</el-button>
              <el-button @click="close">取消</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "alarmEdit",
  props: {},
  computed: {},
  created() {},
  data() {
    return {
      title: '添加告警设置',
      listChangeCallback: null,
      showDialog: false,
      isLoging: false,
      dialogLoading: false,
      form: {
        id: null,
        deviceName: '',
        alarmLevel: '',
        alarmType: '',
        alarmDescription: ''
      },
      alarmLevel: '',
      alarmType: '',
      dropDownList:[],
      levelList:[],
      rules: {
        deviceName: [{ required: true, message: "请输入告警设备名称", trigger: "blur" }],
        alarmLevel: [{ required: true, message: "请选择告警等级", trigger: "blur" }],
        alarmType: [{ required: true, message: "请选择告警类型", trigger: "blur" }],
      },
    };
  },
  methods: {
    openDialog: function (data, callback) {
      this.getDropDownList('1')
      this.getDropDownList('2')
      this.showDialog = true;
      this.title = '添加告警设置'
      this.listChangeCallback = callback;
      if (data != null) {
        this.form.id = data.id;
        this.form.deviceName = data.deviceName;
        this.form.alarmLevel = this.alarmLevel = data.alarmLevel
        this.form.alarmType = this.alarmType = data.alarmType
        this.form.alarmDescription = data.alarmDescription;
        this.title = '编辑告警设置'
      }
    },
    getDropDownList(dicNo){
      let that = this;
      this.$axios({ method: 'get', url:`/api/dic/list`, params: {dicNo: dicNo}}).then( res => {
        if (dicNo=='1') {
          that.dropDownList = res.data.data;
        } else {
          that.levelList = res.data.data;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    changeLevel(val) {
      this.form.alarmLevel = val
    },
    changeCompany(val) {
      this.form.alarmType = val
    },
    onSubmit: function () {
      this.dialogLoading = true;
      var that = this;
      this.$refs.alarmFormRef.validate(flag => {
        //表单验证通过
        if (flag) {
          this.$axios({ method: 'post', url:`/api/warning/update`, params: {...this.form} }).then( res => {
            if (res.data.code == 200) {
              that.$message.success(that.form.id?'修改成功':'添加成功')
              that.showDialog = false;
              if (that.listChangeCallback != null) {
                that.listChangeCallback();
                that.dialogLoading = false;
              }
            } else {
              that.$message.error(res.data.msg)
            }
          }).catch(error => {
            this.dialogLoading = false;
          });
        } else {
          that.dialogLoading = false;
          return this.$message.error('请按照格式要求输入数据')
        }
      })
    },
    close() {
      this.form = {
        id: null,
        deviceName: '',
        alarmLevel: '',
        alarmType: '',
        alarmDescription: ''
      }
      this.alarmLevel = ''
      this.alarmType = ''
      // this.$refs.alarmFormRef.resetFields()
      this.showDialog = false;
      this.dialogLoading = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dialog/alarmEdit.vue